import type { CartResponse } from '../../providers/shopify';
import { BoostAPI } from '../app/app.api';
import type { AppService } from '../app/app.service';
import type { PlatformLoader } from '../platform/platform.loader';

export class CartAPI extends BoostAPI {
  constructor(
    private appService: AppService,
    platformLoader: PlatformLoader
  ) {
    super(platformLoader);
  }

  getCart() {
    return this.get<CartResponse>(this.buildEndpointWithLocale('/cart.js'));
  }

  async getProductsInCart() {
    const response = await this.getCart();
    return response.data.items || [];
  }
}
